import { Box } from '@mui/material';
import React from 'react';
import type { Holder } from '../../data/types';
import { date, dateTime } from '../../lib/format';
import { CHANGE_LABELS } from '../../lib/labels';
import { useTenantScope } from '../../store/selectors';
import DataTable from '../../ui/DataTable';
import { SectionCard, StatusChip } from '../../ui/primitives';

export default function HolderActivityTab({ holder }: { holder: Holder }) {
  const scope = useTenantScope();
  const requests = scope.changeRequests.filter(
    (request) => request.holderId === holder.id || request.toHolderId === holder.id,
  );
  const events = scope.audit.filter(
    (event) =>
      event.target.includes(holder.name) ||
      event.target.includes(holder.id) ||
      event.detail.includes(holder.name),
  );
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <SectionCard title="Change requests" noPadding>
        <DataTable
          rows={requests}
          rowKey={(row) => row.id}
          dense
          emptyMessage="No change requests"
          columns={[
            { key: 'ref', label: 'Reference', render: (row) => row.reference },
            { key: 'kind', label: 'Request', render: (row) => CHANGE_LABELS[row.kind] },
            {
              key: 'channel',
              label: 'Channel',
              render: (row) => row.channel.replace('_', ' ').toLowerCase(),
            },
            { key: 'date', label: 'Submitted', render: (row) => date(row.submittedAt) },
            { key: 'status', label: 'Status', render: (row) => <StatusChip status={row.status} /> },
          ]}
        />
      </SectionCard>
      <SectionCard title="Audit trail" noPadding>
        <DataTable
          rows={events}
          rowKey={(row) => row.id}
          dense
          emptyMessage="No audit events reference this holder yet — try editing their details"
          columns={[
            { key: 'at', label: 'When', render: (row) => dateTime(row.at) },
            { key: 'actor', label: 'Who', render: (row) => row.actor },
            { key: 'action', label: 'Action', render: (row) => row.action },
            { key: 'detail', label: 'Detail', render: (row) => row.detail },
          ]}
        />
      </SectionCard>
    </Box>
  );
}
